import { HTTP_CODE, ERROR_HANDLING_EXPERIENCE } from '../../utils/redirector-utils';

const notFoundHandler = ({ data, guid }) => {
  if (data && !data?.emtContent?.content?.lcpGuid) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Local City Page with ${guid} not found`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.GENERIC
    };
  }

  return null;
};

export { notFoundHandler };